import React, { useState } from "react"
import classnames from "classnames"
import PropTypes from "prop-types"
import { LandingPageContext } from "../contexts/landing-page-context"
import * as styles from "./main-layout.module.css"
import Footer from "../components/Footer"
import Header from "./new-components/Header/Header"

const modeToClass = {
  default: undefined,
  customer: styles.left,
  employee: styles.right,
  products: styles.left,
}
export default function MainLayout({
  children,
  mode = "default",
  showIndustries,
  containerClassName,
  footerClassName,
  HasFooter = false,
}) {
  const [backgroundMode, setBackgroundMode] = useState(mode)

  return (
    <LandingPageContext.Provider value={{ setBackgroundMode }}>
      <div style={{ display: "flex", flex: 1, height: "100vh" }}>
        <div
          className={classnames(styles.background, modeToClass[backgroundMode])}
        >
          <Header scrolled/>
          <div className={classnames(styles.container, containerClassName)}>
            {children}
            {HasFooter && <Footer className={footerClassName} HideBorder />}
          </div>
        </div>
      </div>
    </LandingPageContext.Provider>
  )
}

MainLayout.defaultProps = {
  background: "default",
  showIndustries: true,
}

MainLayout.propTypes = {
  children: PropTypes.element.isRequired,
  mode: PropTypes.string.isRequired,
  showIndustries: PropTypes.bool,
  containerClassName: PropTypes.string,
  HasFooter: PropTypes.bool,
  footerClassName: PropTypes.string,
}
